export const holiday = {
  "Voltar": "Voltar",
  "Solicitação para o dia ": "Solicitação para o dia ",
  "Acessar perfil": "Acessar perfil",
  "Cancelar": "Cancelar",
  "Tipo da solicitação:": "Tipo da solicitação:",
  "Período:": "Período:",
  "Observação:": "Observação:",
  "Anexo:": "Anexo:",
  "Ver anexo": "Ver anexo",
  "por:": "por:",
  "em": "em",
  "Avalie a solicitação": "Avalie a solicitação",
  "Recusar": "Recusar",
  "Aprovar": "Aprovar",
  "Enviar notificação por e-mail": "Enviar notificação por e-mail",
  "Finalizar solicitação": "Finalizar solicitação",
  "Reprovado": "Reprovado",
  "Aprovado/Cadastrado": "Aprovado/Cadastrado",
  "Aviso": "Aviso",
  "Férias e afastamentos": "Férias e afastamentos",
  "Solicitar Férias ou Afastamento": "Solicitar Férias ou Afastamento",
  "Minhas férias e afastamentos": "Minhas férias e afastamentos",
  "Período": "Período",
  "Pesquisar": "Pesquisar",
  "Tipo": "Tipo",
  "Data de início e fim<": "Data de início e fim<",
  "Qtde de dias": "Qtde de dias",
  "Motivo": "Motivo",
  "Situação": "Situação",
  "Ação": "Ação",
  "Visualizar": "Visualizar",
  "Nenhuma solicitação de férias ou afastamento cadastrada no Ano selecionado.": "Nenhuma solicitação de férias ou afastamento cadastrada no Ano selecionado.",
  "Tivemos um problema com a conexão, tente novamente atualizando a página.": "Tivemos um problema com a conexão, tente novamente atualizando a página.",
  "dia": "dia",
  "dias": "dias",
  "Gerenciar férias e afastamentos": "Gerenciar férias e afastamentos",
  "Funcionário": "Funcionário",
  "Data de início e fim": "Data de início e fim",
  "Solicitar Férias/Afastamento": "Solicitar Férias/Afastamento",
  "Férias": "Férias",
  "Afastamento": "Afastamento",
  "Tipo de afastamento": "Tipo de afastamento",
  "Selecione": "Selecione",
  "Campo obrigatório.": "Campo obrigatório.",
  "Início": "Início",
  "Término": "Término",
  "Quantidade de dias": "Quantidade de dias",
  "Adicionar anexo": "Adicionar anexo",
  "Motivo do ponto por exceção": "Motivo do ponto por exceção",
  "Observação": "Observação",
  "Enviar Solicitação": "Enviar Solicitação",
  "Não foi possivel realizar o envio da imagem.\\n\\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.": "Não foi possivel realizar o envio da imagem.\\n\\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.",
  "Sucesso": "Sucesso",
  "Solicitação realizada com sucesso.": "Solicitação realizada com sucesso."
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/holiday.js